import React from 'react';
import { Switch, Route as PublicRoute, BrowserRouter as Router } from 'react-router-dom';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import '@ag-grid-community/core/dist/styles/ag-theme-material.css';
import './App.css';
import AppRoutes from './app/AppRoutes';
import { PrivateRoute } from './app/hoc/PrivateRoute/PrivateRoute';
import DownloadCenterLanding from './app/pages/DownloadCenterLanding/DownloadCenterLanding';
import ApplicationHeader from './app/components/ApplicationHeader/ApplicationHeader';
import MBSHeader from "./app/components/ApplicationHeader/MBSHeader";
import { useAuthStore } from '@fides/fides-react-components';

function App() {
  const user = useAuthStore(state => state.user);

  return (
    
    <div className="App">
      <Router>
        <Switch>
          <PublicRoute exact path="/loggedout">
            <DownloadCenterLanding />
          </PublicRoute>
          <PrivateRoute path="/">
            { user?.isCSEndUser ? <ApplicationHeader /> : <MBSHeader /> }
            <AppRoutes />
          </PrivateRoute>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
